<div style="padding: 10%; text-align: center">
  <p>Desculpe, não encontramos essa página :(</p>
  <app-button routerLink="/companies">IR PARA PÁGINA INICIAL</app-button>
</div>
